/**
 * Tagesgrenzen in der Zeitzone der Person (CUPR-101).
 */
/** Start von „heute" (UTC-Instant) in der angegebenen IANA-Zeitzone. */
export function heuteStart(zeitzone, jetzt = new Date()) {
    const fmt = new Intl.DateTimeFormat("en-CA", {
        timeZone: zeitzone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    const tag = fmt.format(jetzt); // YYYY-MM-DD
    // Finde UTC-Zeit, die in der TZ Mitternacht ist — Näherung über Offset
    const probe = new Date(`${tag}T12:00:00.000Z`);
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: zeitzone,
        hour: "numeric",
        hourCycle: "h23",
        timeZoneName: "shortOffset",
    }).formatToParts(probe);
    const offsetPart = parts.find((p) => p.type === "timeZoneName")?.value ?? "GMT";
    const m = /GMT([+-]\d{1,2})(?::?(\d{2}))?/.exec(offsetPart);
    let offsetMin = 0;
    if (m) {
        const h = Number(m[1]);
        const min = Number(m[2] ?? "0");
        offsetMin = h * 60 + Math.sign(h || 1) * min;
    }
    // Mitternacht lokal = tag 00:00 = UTC - offset
    const [y, mo, d] = tag.split("-").map(Number);
    const utcMs = Date.UTC(y, mo - 1, d, 0, 0, 0) - offsetMin * 60_000;
    return new Date(utcMs);
}
export function heuteEnde(zeitzone, jetzt = new Date()) {
    const start = heuteStart(zeitzone, jetzt);
    return new Date(start.getTime() + 24 * 60 * 60 * 1000);
}
export function istHeuteFaellig(faelligAm, zeitzone, jetzt = new Date()) {
    const a = heuteStart(zeitzone, jetzt).getTime();
    const b = heuteEnde(zeitzone, jetzt).getTime();
    const t = faelligAm.getTime();
    return t >= a && t < b;
}
/** Kalendertag `YYYY-MM-DD` am Ort der Person, unabhängig von der Server-TZ. */
export function kalendertagInZeitzone(zeitzone, jetzt = new Date()) {
    const teile = new Intl.DateTimeFormat("en-CA", {
        timeZone: zeitzone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(jetzt);
    const wert = (art) => teile.find((teil) => teil.type === art)?.value ?? "";
    return `${wert("year")}-${wert("month")}-${wert("day")}`;
}
/** Strikte Prüfung statt bloßem Muster: `2026-02-31` ist kein Kalendertag. */
export function istGueltigerKalendertag(wert) {
    const treffer = /^(\d{4})-(\d{2})-(\d{2})$/.exec(wert);
    if (!treffer)
        return false;
    const jahr = Number(treffer[1]);
    const monat = Number(treffer[2]);
    const tag = Number(treffer[3]);
    const datum = new Date(Date.UTC(jahr, monat - 1, tag));
    return (datum.getUTCFullYear() === jahr &&
        datum.getUTCMonth() === monat - 1 &&
        datum.getUTCDate() === tag);
}
//# sourceMappingURL=zeitzone.js.map